'use client';

import { __assign } from '../_virtual/_tslib.js';
import { getCookie, setCookie } from '../Utils/cookie.js';

var initProfileSettingOptions = {
    chooseCV: 'attach-cv',
    chooseRefreshType: 2
};
var getProfileSettingCookie = function (userId) {
    if (userId) {
        var data = JSON.parse(getCookie('VNW_PROFILE_SETTING_OPTIONS') || '{}');
        !data[userId] && setCookie('VNW_PROFILE_SETTING_OPTIONS', JSON.stringify(data), 0);
        return !data[userId] ? initProfileSettingOptions : data[userId];
    }
    return null;
};
var setProfileSettingCookie = function (newOptions, userId) {
    if (userId) {
        var data = JSON.parse(getCookie('VNW_PROFILE_SETTING_OPTIONS') || '{}');
        if (!data[userId]) {
            data[userId] = initProfileSettingOptions;
            setCookie('VNW_PROFILE_SETTING_OPTIONS', JSON.stringify(data), 0);
        }
        else {
            data[userId] = __assign(__assign({}, data[userId]), newOptions);
            setCookie('VNW_PROFILE_SETTING_OPTIONS', JSON.stringify(data), 0);
        }
    }
};

export { getProfileSettingCookie, initProfileSettingOptions, setProfileSettingCookie };
//# sourceMappingURL=utils.js.map
